import React from 'react'
import accessIcon from '../../../assets/icons/entryDoor-black.svg'
import exitIcon from '../../../assets/icons/departureDoor-black.svg'
import { t } from 'i18next'
import PermanenceTotals from '../PermanenceTotals/PermanenceTotals'
import { getTenantInfoByKey, isoToDate } from '../../../helpers/helpers'

const PermanenceDetailTotals = ({ accessEmpDetail }) => {
    const totals = {
        hs_50: accessEmpDetail.hs_50,
        hs_100: accessEmpDetail.hs_100,
        hs_normal: accessEmpDetail.hs_norm
    };


    const [dateIn, timeIn] = isoToDate(accessEmpDetail.dateIn).split('T');

    const [dateOut, timeOut] = isoToDate(accessEmpDetail.dateOut).split('T');

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening')
    const haveBuildings = getTenantInfoByKey('is_building')

    const title = () => {
        if (haveAccessOpenings === false && haveBuildings === false) {
            return t('PLANT_RESOURCES')
        }

        if (haveAccessOpenings === false && haveBuildings === true) {
            return accessEmpDetail.building ? accessEmpDetail.building : t('NO_ASSIGNMENT');
        }

        if (haveAccessOpenings === true && haveBuildings === true) {
            return `${accessEmpDetail.opening ? accessEmpDetail.opening : t('NO_ASSIGNMENT')}${accessEmpDetail.building ? (' - ' + accessEmpDetail.building) : ''}`;
        }

        if (haveAccessOpenings === true && haveBuildings === false) {
            return `${accessEmpDetail.opening ? accessEmpDetail.opening : t('NO_ASSIGNMENT')}`;
        }

    }

    return (
        <div>
            <div className='pe-4 ps-4 pt-3 pb-3' style={{ background: '#EFF7FE' }}>
                <h6 className='dark-text'>
                    <strong>{title()}</strong>
                </h6>
                <div className='d-flex align-items-start gap-4'>
                    <div className='d-flex align-items-start gap-2'>
                        <img src={accessIcon} alt="" />
                        <div>
                            <span className='dark-text'><strong>{t('ENTRY')}</strong> <span className='text-description'> {t('BY')} {accessEmpDetail.userIn}</span></span>
                            <span className='d-block dark-text'>
                                <strong>{dateIn} {timeIn.slice(0, 5)}</strong>
                            </span>
                        </div>
                    </div>
                    <div className='d-flex align-items-start gap-2'>
                        <img src={exitIcon} alt="" />
                        <div>
                            <span className='dark-text'><strong>{t('DEPARTURE')}</strong> <span className='text-description'> {t('BY')} {accessEmpDetail.userOut ? accessEmpDetail.userOut : '-'}</span></span>
                            <span className='d-block dark-text'>
                                <strong>{dateOut} {timeOut.slice(0, 5)}</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-3 mb-3'>
                <PermanenceTotals haveDetail={false} borders='' totals={totals} />
            </div>
        </div>
    )
}

export default PermanenceDetailTotals